<!--<c-footer>-->
  <div>
    <a href="" target="_blank">Backoffice</a>
    <span>  Versão: {{ version }}</span>
  </div>
<!--</c-footer>-->
